import React from 'react';
import { Table, Popconfirm, Button } from 'antd';
import moment from 'moment';
import styles from './PromosTable.module.css';

const { Column } = Table;

const renderDate = utime => {
  if (utime !== 0) {
    const t = moment.unix(utime);
    return t.format('ll');
  }
  return '';
};

const PromoSelector = props => {
  const { promos, handleSave } = props;

  return (
    <div>
      <h3>Select a promotion to add cart products to</h3>
      <Table
        bordered
        className={styles.Table}
        rowKey={record => record.id}
        size="small"
        expandedRowRender={record => (
          <div>
            <strong>Description</strong>
            <p style={{ margin: 0 }}>{record.description}</p>
          </div>
        )}
        dataSource={promos}
      >
        <Column
          key="action"
          render={row => (
            <Popconfirm title="Add selected products to this promotion?" onConfirm={() => handleSave(row.id)}>
              <Button type="primary">Select</Button>
            </Popconfirm>
          )}
        />
        <Column title="ID" dataIndex="id" key="id" />
        <Column title="Title" dataIndex="title" key="title" />
        <Column title="Starts" dataIndex="start_date" key="start_date" render={utime => renderDate(utime)} />
        <Column title="Ends" dataIndex="end_date" key="end_date" render={utime => renderDate(utime)} />
      </Table>
    </div>
  );
};

export default PromoSelector;



// WEBPACK FOOTER //
// ./src/components/Promo/PromoSelector.js